var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80302 3.46967C9.09592 3.17678 9.57079 3.17678 9.86368 3.46967L13.8637 7.46967C14.1566 7.76256 14.1566 8.23744 13.8637 8.53033L9.86368 12.5303C9.57079 12.8232 9.09592 12.8232 8.80302 12.5303C8.51013 12.2374 8.51013 11.7626 8.80302 11.4697L11.5227 8.75H6.33335C5.91914 8.75 5.58335 8.41421 5.58335 8C5.58335 7.58579 5.91914 7.25 6.33335 7.25H11.5227L8.80302 4.53033C8.51013 4.23744 8.51013 3.76256 8.80302 3.46967ZM1.91669 8C1.91669 7.58579 2.25247 7.25 2.66669 7.25H4.33335C4.74757 7.25 5.08335 7.58579 5.08335 8C5.08335 8.41421 4.74757 8.75 4.33335 8.75H2.66669C2.25247 8.75 1.91669 8.41421 1.91669 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.b8bcc1de.svg";
export { ForwardRef as ReactComponent };